// extracted by extract-css-chunks-webpack-plugin
module.exports = {"text-decoration-none":"Link-module_text-decoration-none__1btxd"};